(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroImageSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero__slideshow-slide'));
      this.currentIndex = 0;
      this.intervalMs = Number(this.dataset.interval) || 5000;

      if (this.slides.length <= 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.start();

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange = () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    };

    start() {
      this.stop();
      if (this.slides.length <= 1) return;
      this.timer = window.setInterval(() => this.next(), this.intervalMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.slides[this.currentIndex]?.classList.remove('is-active');
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.slides[this.currentIndex]?.classList.add('is-active');
    }
  }

  if (!customElements.get('hero-image-slideshow')) {
    customElements.define('hero-image-slideshow', HeroImageSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
